// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'font', 'font Fallback'"},"className":"__className_7d60c3"};